import { GridCellParams } from '@mui/x-data-grid-premium'
import { GridValidRowModel } from '@mui/x-data-grid-pro'
import React from 'react'
import LoadingShimmer from 'src/components/LoadingShimmer/LoadingShimmer'

import DataGridCellWrapper from './DataGridCellWrapper/DataGridCellWrapper'

interface LoadingCellProps<Row extends GridValidRowModel> {
  params: GridCellParams<Row>
}

const LoadingCell = <Row extends GridValidRowModel>(
  props: LoadingCellProps<Row>,
): React.ReactElement => {
  return (
    <DataGridCellWrapper params={props.params}>
      <LoadingShimmer />
    </DataGridCellWrapper>
  )
}

export default LoadingCell
